let host = 'http://xlapi.hebeijiaoyu.com.cn/';
// let host = 'http://www.xinlizixun.com/';
export default host;


// WEBPACK FOOTER //
// ./src/host.js